import React from "react";
import { Navigate } from "react-router-dom";


const PublicRoutes = ({children}) =>{
    const auth = localStorage.getItem('able-auctions');

    if(auth){
        return <Navigate to="/" replace/>
    }
    return children
}

export default PublicRoutes